import Vue from 'vue';
import Router from 'vue-router';
import { store } from '../_store';

/*
import HomePage         from '../home/HomePage'
import LoginPage        from '../login/LoginPage'
*/


Vue.use(Router);

export const router = new Router({
  originalRoute: 'Home',
  mode: 'history',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
          if (savedPosition) {
              resolve( savedPosition )
            }        
            else resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { 
      path: '/', 
      name: 'Home',
      component: () => import('../home/HomePage'),
      //meta: { breadcrumb: 'Start' } 
    },

    { 
      path: '/login', 
      name: 'LoginPage',
      component: () => import('../login/LoginPage'),
      meta: { transitionName: 'fade' },
    },

    { 
      path: '/signup', 
      name: 'SignUp',
      component: () => import('../login/SignUpPage'),
      meta: { transitionName: 'fade' },
    },

    {
      path: '/thankyou',
      name: 'ThankyouPage',
      component: () => import('../login/ThankyouPage'),
      meta: { transitionName: 'fade' },
    },
    
    {
      path: '/activate/:key',
      name: 'ActivationPage',
      component: () => import('../login/ActivationPage'),
      meta: { transitionName: 'fade' }
    },

/*
    { 
      path: '/login/:r', 
      name: 'LoginPage',
      component: () => import('../login/LoginPage')
    },
*/


    { 
      path: '/manager', 
      name: 'AdminPage',
      component: () => import('../manager/AdminPage')
    },
    { 
      path: '/manager/products', 
      name: 'ProductsAdmin',
      component: () => import('../manager/ProductsAdmin')
    },

    { 
      path: '/manager/product/:articlenumber', 
      name: 'Product',
      component: () => import('../manager/Product')
    },



    { 
      path: '/product/:articlenumber', 
      name:'ProductPage', 
      component: () => import('../views/ProductPage')
    },
    
    


/*
    {
      path: '/kategorien/:q',
      name: 'CategoriesPage',
      component: () => import('../views/CategoriesPage')
    },
    {
      path: '/kategorie/bio',
      name: 'BioPage',
      component: () => import('../views/BioPage')
    },
    {
      path: '/kategorie/:c/:s',
      name: 'CategoryPage',
      component: () => import('../views/CategoryPage')
    },
*/



/*

    {
      path: '/basket',
      name: 'BasketPage',
      component: () => import('../views/BasketPage')
    },
    {
      path: '/checkout',
      name: 'CheckoutPage',
      component: () => import('../views/CheckoutPage')
    },
*/




    {
      path: '/user',
      name: 'UserPage',
      component: () => import('../views/UserPage')
    },

    {
      path: '/projects',
      name: 'ProjectsPage',
      component: () => import('../views/ProjectsPage')
    },

    { 
      path: '/projects/:projectid', 
      name:'ProjectPage', 
      component: () => import('../views/ProjectPage')
    },

    {
      path: '/about',
      name: 'AboutPage',
      component: () => import('../views/content/AboutPage')
    },

    {
      path: '/koehler',
      name: 'KoehlerPage',
      component: () => import('../views/content/KoehlerPage')
    },

    {
      path: '/imprint',
      name: 'ImprintPage',
      component: () => import('../views/content/ImprintPage')
    },
    
    {
      path: '/privacy',
      name: 'PrivacyPage',
      component: () => import('../views/content/PrivacyPage')
    },




/*
    {
      path: '/user/orders/:i',
      name: 'OrderPage',
      component: () => import('../views/OrderPage')
    },
*/


    {
      path: '/favorites',
      name: 'FavoritesPage',
      component: () => import('../views/FavoritesPage')
    },


    // otherwise redirect to home
    { path: '*', redirect: '/' }
  ]
});


/*
async beforeEnter(to, from, next) {
  try {
    var hasPermission = await store.dispatch("auth/hasPermission");
    if (hasPermission) {
      next()
    }
  } catch (e) {
    next({
      name: "login", // back to safety route //
      query: { redirectFrom: to.fullPath }
    })
  }
}
*/


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const userPages = [ '/user', '/favorites', '/projects' ];
  const authRequired = userPages.includes(to.path);
  
  const adminPages = ['/manager','/manager/editproduct', 'manager/products'];
  const adminAuthRequired = adminPages.includes(to.path);

  const loggedIn = localStorage.getItem('user');
  
  if(authRequired || adminAuthRequired)
      store.dispatch('authentication/checkAuth');


  if( (adminAuthRequired && loggedIn) ) {
    let user = JSON.parse(loggedIn);
    console.log( user )

    if(user.role != "admin" ) return next('/');
    else next();
  }

  if ( (authRequired || adminAuthRequired) && !loggedIn ) { 
    router.originalRoute = to.name;
    return next('/login' );
  }
  

  next();
})